module.exports = __webpack_public_path__ + "static/media/kameiHappyHour10172025.72967cb0.pdf";